import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { Avatar } from '@domain-group/fe-blueprint-ui/avatar';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { AgentAwardPill } from '@domain-group/fe-co-allhomes-shared-components';
import * as styles from './carousel-agent-card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var agentCardContents = (agent, largePhoto) => ___EmotionJSX("div", null, ___EmotionJSX(Avatar, {
  css: styles.avatar({
    largePhoto
  }),
  imageUrl: agent.profilePhoto,
  size: "custom"
}), ___EmotionJSX("p", {
  css: styles.name
}, agent.name));
var AgentCard = _ref => {
  var _agent$awards;
  var agent = _ref.agent,
    largePhoto = _ref.largePhoto;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  return ___EmotionJSX("div", {
    "data-testid": "agent",
    key: agent.name,
    css: styles.agent
  }, agent.profileUrl && !isEmpty(agent.profileUrl) && ___EmotionJSX("a", {
    key: agent.name,
    css: styles.agentLink,
    href: agent.profileUrl,
    onClick: () => sendEvent('agent-sidebox-profile-click', {
      agentId: agent.id,
      agentName: agent.name,
      agencyId: agent.agency.id,
      agencyName: agent.agency.name
    })
  }, agentCardContents(agent, largePhoto)), isEmpty(agent.profileUrl) && ___EmotionJSX("span", {
    key: agent.name,
    css: styles.agentLink
  }, agentCardContents(agent, largePhoto)), ___EmotionJSX("p", {
    css: styles.agency
  }, agent.agency.name), (_agent$awards = agent.awards) === null || _agent$awards === void 0 ? void 0 : _agent$awards.map(award => ___EmotionJSX("div", {
    css: styles.awardPill
  }, ___EmotionJSX(AgentAwardPill, {
    label: award.badgeLabel
  }))));
};
export default AgentCard;